import * as React from 'react';
import { styled } from '@glitz/react';
import { createMinMediumViewportDecorator } from 'webapp/viewport';
import { translate, useDynamicData } from '@avensia/excite';
import { Bubble } from 'webapp/components/bubble';
import { isSvenssons } from 'webapp/theme';
import { useFormatPrice } from '@avensia/excite-ui';

export function FreeShippingBubble() {
  const formatPrice = useFormatPrice();
  const [amountLeftForFreeShipping] = useDynamicData<Excite.Commercetools.CartApiModel, number | undefined>({
    selector: data => data?.viewData?.amountLeftForFreeShipping?.inclVat,
  });

  if (typeof amountLeftForFreeShipping === 'number') {
    return (
      <FreeShippingBubbleWrapper>
        <FreeShippingSpeechBubble>
          {translate(t => t.miniCart.amountLeftForFreeShipping, {
            amount: formatPrice(amountLeftForFreeShipping),
          })}
        </FreeShippingSpeechBubble>
      </FreeShippingBubbleWrapper>
    );
  }

  return null;
}

const FreeShippingBubbleWrapper = styled.div(
  createMinMediumViewportDecorator({
    width: 'auto',
  }),
  {
    width: '100%',
    gridColumn: { start: 3 },
    marginBottom: t => t.sharedSpacing.l,
  },
);

const FreeShippingSpeechBubble = styled(
  Bubble,
  createMinMediumViewportDecorator({
    maxWidth: 200,
    textAlign: 'left',
  }),
  {
    marginTop: 0,
    width: '100%',
    marginLeft: 'auto',
    fontSize: t => t.sharedFontSize.xs,
    fontWeight: isSvenssons ? '400' : '500',
    textAlign: 'center',
    right: '0',
  },
);
